import '../DashboardSkeleton.css';
import './SearchShimmer.css';

export function searchIsLoading(query, hasData = Boolean(query.data)) {
  return Boolean((query.isLoading || query.isPending || query.isFetching) && (!hasData || query.isPlaceholderData) && !query.isError);
}

const Line = ({ short = false, title = false }) => <span className={`dashboard-skeleton dashboard-skeleton--line search-shimmer__line ${short ? 'search-shimmer__line--short' : ''} ${title ? 'search-shimmer__line--title' : ''}`} />;
const Icon = () => <span className="dashboard-skeleton dashboard-skeleton--icon" />;
const Lines = ({ count = 3 }) => <div className="search-shimmer__stack">{Array.from({ length: count }, (_, index) => <Line key={index} short={index === count - 1} />)}</div>;
const Stats = () => <div className="qbl-questionCard__footer search-shimmer__stats">{Array.from({ length: 4 }, (_, index) => <Line key={index} />)}</div>;

export function SearchInlineShimmer({ label = 'Loading content', count = 3 }) {
  return <div role="status" aria-label={label} aria-busy="true"><div aria-hidden="true"><Lines count={count} /></div></div>;
}

export function SearchResultsShimmer({ categoryId = 2, count = 6, label = 'Loading search results' }) {
  const quiz = categoryId === 1;
  const series = categoryId === 0;
  return <div role="status" aria-label={label} aria-busy="true" className="search-shimmer">
    <div aria-hidden="true" className={quiz ? 'quizz-test-wrapper' : series ? 'test-series-wrapper' : 'qbl-questionList'}>
      {Array.from({ length: count }, (_, index) => <div key={index} className={quiz ? 'quizz-test-card' : series ? 'test-series-card' : 'qbl-questionCard'}>
        <div className="qbl-questionCard__head search-shimmer__head"><Icon /><Line title /><Icon /></div>
        <Lines count={categoryId === 7 ? 2 : 3} />
        {(quiz || series) && <><Line /><div className="search-shimmer__progress dashboard-skeleton" /></>}
        {categoryId !== 7 && <Stats />}
      </div>)}
    </div>
  </div>;
}

export function SearchDetailShimmer({ variant = 'question' }) {
  const video = variant === 'lecture' || variant === 'demo';
  return <div role="status" aria-label="Loading content" aria-busy="true" className="search-shimmer">
    <div className="d-flex qbank-detail-main" aria-hidden="true">
      <section className="qbank-LeftContent"><div className="qbank-card qbank-card--question">
        <div className="qbank-questionTop search-shimmer__head"><Line short /><Line short /><Icon /></div>
        <Line title />
        {video ? <div className="dashboard-skeleton search-shimmer__video" /> : variant === 'note' ? <div className="dashboard-skeleton search-shimmer__document" /> : <Lines count={4} />}
        {variant === 'question' && <div className="qbank-options">{Array.from({ length: 4 }, (_, index) => <div key={index} className="qbank-option"><Icon /><Line /></div>)}</div>}
        <Stats />
      </div></section>
      {variant !== 'demo' && <aside className="qbank-rightContent">{Array.from({ length: 3 }, (_, index) => <section className="qbank-sideCard" key={index}><div className="qbank-sideCard__head"><Line title /></div><div className="qbank-sideCard__body"><Lines /></div></section>)}</aside>}
    </div>
  </div>;
}
